import { Spinner } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { StressAssessmentReportDownload } from '~/features/StressAssessmentReportDownload';
import { StressAssessmentReportDownloadBreadcrumb } from '~/features/StressAssessmentReportDownloadBreadcrumb';
import { StressAssessmentScheduleNotificationBanner } from '~/features/StressAssessmentScheduleNotificationBanner';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const stressAssessmentId = Number.parseInt(id || '', 10);

  if (Number.isNaN(stressAssessmentId)) {
    // idが数値でない場合は、stress-assessmentsにリダイレクト
    return <Navigate to={ROUTES.STRESS_ASSESSMENTS.INDEX} replace />;
  }

  return (
    <div className={styles.Screen}>
      <ClientSideMenu />
      <div className={styles.ContentWrapper}>
        <div className={styles.BreadcrumbWrapper}>
          <StressAssessmentReportDownloadBreadcrumb stressAssessmentId={stressAssessmentId} />
        </div>
        <div className={styles.Content}>
          <Suspense fallback={<Spinner />}>
            <StressAssessmentReportDownload />
          </Suspense>
        </div>
      </div>
      <div className={styles.BannerWrapper}>
        <Suspense fallback={null}>
          <StressAssessmentScheduleNotificationBanner />
        </Suspense>
      </div>
    </div>
  );
};
